module.exports = __webpack_public_path__ + "static/media/HA research.1f056012.png";